import values from 'mout/object/values'
import totalArray from '../totalArray'
import forOwn from 'mout/object/forOwn'

export default function getPercentQuestionData ( item, answers, nodes ) {
  // total all of the answers
  const choiceNum = values(item.answers).length
  let percents = []

  let correct = null
  values(item.answers).forEach((choice, n) => {
    if (choice.correct) {
      correct = n
    }
  })

  let nodeId = ''
  forOwn(item.nodeTags, (val, key) => {
    if (val) {
      nodeId = key
    }
  })
  const skill = nodes[nodeId].name

  if (answers) {
    const total = totalArray(values(answers))
    
    for (let i = 0; i < choiceNum; i++) {
      if (answers[`answer000${i}`]) {
        percents.push(Math.round(answers[`answer000${i}`] / total * 100))
      } else {
        percents.push(0)
      }
    }
  } else {
    for (let i = 0; i < choiceNum; i++) {
      percents.push(0)
    }
  }

  return {
    percents,
    correct,
    skill,
  }
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/getPercentQuestionData.js